import React, { Component } from 'react';
import { Form, Button, Col, Container,Row } from 'react-bootstrap';
import { sportEndPoint } from "../../constant/Environment";
import { getAllSportData } from "../../Utility/API";

class ResultSearch extends Component{
    constructor(props) {
        super(props);
        console.log(props);
      }
      state = {
        code: "",
        sports:[],
        leagues:[],
        platform:"",
        fromdate: "",
        todate: "",
        market: "",
        leage: "",
        sport:"",
        period:"1m"
      };

      searchBetData = () => {
       var body = {
            code: this.state.code,
            platform:this.state.platform,
            status:this.props.report,
            fromDate: this.state.fromdate,
            toDate: this.state.todate,
            market: this.state.market,
            tournament: this.state.leage,
            sport:this.state.sport,
            type:"LIST",
            period: this.state.period
          };
        this.props.searchBetData(body);
       }
      sports = async () => {

        let url = `${sportEndPoint.apiBaseUrl+sportEndPoint.api.sports}`;
          await getAllSportData(url)
            .then((response) => {
              //console.log("data", response);
              if (response) {
                this.setState({ sports: response })
              } else {
              }
            })
            .catch((error) => {
              console.error(error);
            });
    };
    leagueList = async () => {
       
        let url = `${sportEndPoint.apiBaseUrl+sportEndPoint.api.leagueList}`;
        await getAllSportData(url)
          .then((response) => {
            //console.log("data", response);
            if (response) {
              this.setState({ leagues: response })
            } else {
            }
          })
          .catch((error) => {
            console.error(error);
          });
    };

    createSelectItems(data) {
        let items = [];         
        for (let i = 0; i < data.length; i++) {  
             items.push(<option key={i} value={data[i].id}>{data[i].name}</option>); 
        }
        return items;
    }  
    exportCsv = (e) => {
        e.preventDefault();
        var body = {
            code: this.state.code,
            platform:this.state.platform,
            status:this.props.report,
            fromDate: this.state.fromdate,
            toDate: this.state.todate,
            market: this.state.market,
            tournament: this.state.leage,
            sport:this.state.sport,
            type:"csv",
            period: this.state.period
          };
        fetch(`${sportEndPoint.apiBaseUrl+sportEndPoint.api.REPORT}`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(function(response) {
                    response.blob().then(blob => {
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        console.log(url);
                        link.href = url;
                        link.download = 'ResultBetsReport.csv';
                        link.click();
                    })
                   
                });
    };
    exportPdf = (e) => {
        e.preventDefault();
               var body = {
            code: this.state.code,
            platform:this.state.platform,
            status:this.props.report,
            fromDate: this.state.fromdate,
            toDate: this.state.todate,
            market: this.state.market,
            tournament: this.state.leage,
            sport:this.state.sport,
            type:"pdf",
            period: this.state.period
          };

        fetch(`${sportEndPoint.apiBaseUrl+sportEndPoint.api.REPORT}`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(function(response) {
                    response.blob().then(blob => {
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                       
                        link.href = url;
                        link.download = 'ResultBetsReport.pdf';
                        link.click();
                    })
                });
    };
    componentDidMount() {
        this.leagueList();
        this.sports();
    }
    
    render() {
  
        return( <Container fluid>
                    <Form>
                    <Row>
                   
   <Col>
                            <Form.Group as={Col} controlId="betCode">
                                <Form.Label className="label">Code</Form.Label>
                                <Form.Control
                                type="text"                              
                                name="betCode"
                                value={this.state.code}
                                onChange={e => this.setState({ code: e.target.value })}
                                required
                              
                                />
                            </Form.Group>
                            </Col>
                      
                            <Col>
                            <Form.Group as={Col} controlId="formDate">
                                <Form.Label className="label">From Date</Form.Label>
                                <Form.Control
                                type="date"                           
                                name="formDate"
                                value={this.state.fromdate}
                                onChange={e => this.setState({ fromdate: e.target.value })}
                                required
                           
                                />
                            </Form.Group>
                            </Col>
                            <Col>
                            <Form.Group as={Col} controlId="toDate">
                                <Form.Label className="label">To Date</Form.Label>
                                <Form.Control
                                type="date"                           
                                name="toDate"
                                value={this.state.todate}
                                onChange={e => this.setState({ todate: e.target.value })}
                                required
                           
                                />
                            </Form.Group>
                            </Col>
                           
                       

                        <Col>
                            <Form.Group as={Col} controlId="formPlatform">
                                <Form.Label className="label">Platform</Form.Label>
                                <Form.Select                    
                                name="platform"
                                value={this.state.platform}
                                onChange={e => this.setState({ platform: e.target.value })}                           
                                >
                                    
                        <option value="">All</option>
                        <option value="WEB">WEB</option>
                        <option value="MOBILE">MOBILE</option>
                                </Form.Select>
                            </Form.Group>
                            </Col>  
                            {/* <Col></Col>  */}
                            <Col>
            
                            </Col>
                     
                        </Row>
                        <Row>
                   
                            <Col>
                            <Form.Group as={Col} controlId="leage">
                                <Form.Label className="label">Tournament</Form.Label>
                                <Form.Select                    
                                name="leage"
                                value={this.state.leage}
                                onChange={e => this.setState({ leage: e.target.value })}  
                                required                           
                                >
                                    
                                    <option value="">Select Tournament</option>
                      {this.createSelectItems(this.state.leagues)}
                                </Form.Select>
                            </Form.Group>
                            </Col>
                            <Col>
                            <Form.Group as={Col} controlId="sport">
                                <Form.Label className="label">Sport</Form.Label>
                                <Form.Select                    
                                value={this.state.sport}
                                onChange={e => this.setState({ sport: e.target.value })} 
                                required                           
                                >
                                    <option value="">Select Sport</option>
                                    {this.createSelectItems(this.state.sports)}
                                </Form.Select>
                            </Form.Group>
                            </Col>
                            <Col>
                            <Form.Group as={Col} controlId="market">
                                <Form.Label className="label">Market</Form.Label>
                                <Form.Select                    
                                name="market"
                                value={this.state.market}
                                onChange={e => this.setState({ market: e.target.value })} 
                                required                           
                                >
                                    <option value="">Select Market</option>
                                    <option value="342">Spread</option>
                <option value="226">Money Line</option>
                <option value="28">Total</option>
                                </Form.Select>
                            </Form.Group>
                            </Col>
                            <Col>
   <Button className='exportbtn' onClick={this.exportPdf}>
   <img src="/images/icons/pdf.png" />
   </Button>
   <Button className='exportbtn' onClick={this.exportCsv}>
   <img src="/images/icons/csv.png" />
   </Button>
   </Col>
   <Col>
                        <Button variant="primary" onClick={this.searchBetData}>Search</Button>
                        
                           </Col>
                        </Row>
                       
                    </Form>
                </Container>
        );
    }
}

export default ResultSearch;